export enum IconType {
  SVG = "SVG",
  ICON_FONT = "FA",
  SRC = "SRC"
}
